<div class="container">
    <form [formGroup]="formulario">

        <div class="row pt-1">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Contrato Juridico</mat-label>
                    <input matInput id="txtContratoJur" #txtContratoJur maxlength="20"
                        formControlName="contrato_juridico">
                    <mat-hint align="end">{{txtContratoJur.value.length}} / 20</mat-hint>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Hibrido</mat-label>
                    <input matInput id="txtRnc" #txtRnc maxlength="20"
                        formControlName="hibrido_rnc">
                    <mat-hint align="end">{{txtRnc.value.length}} / 20</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div class="row pt-1">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Espécie</mat-label>
                    <input matInput id="txtEspc" #txtEspc maxlength="20"
                        formControlName="especie">
                    <mat-hint align="end">{{txtEspc.value.length}} / 20</mat-hint>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Safra</mat-label>
                    <input matInput id="txtSafra" #txtSafra maxlength="20"
                        formControlName="safra">
                    <mat-hint align="end">{{txtSafra.value.length}} / 20</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div class="row pt-1">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Ano</mat-label>
                    <input matInput id="txtAno" #txtAno maxlength="4"
                    formControlName="ano" type="number" >
                    <mat-hint align="end">{{txtAno.value.length}} / 4</mat-hint>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Geração</mat-label>
                    <input matInput id="txtGeracao" #txtGeracao maxlength="20"
                    formControlName="geracao"  >
                    <mat-hint align="end">{{txtGeracao.value.length}} / 20</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div class="row pt-1">
            <div class="col-lg-12 col-md-12">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Site Origem</mat-label>
                    <input matInput id="txtSiteOrigem" #txtSiteOrigem maxlength="20"
                    formControlName="site_origem" >
                    <mat-hint align="end">{{txtSiteOrigem.value.length}} / 20</mat-hint>
                </mat-form-field>
            </div>
        </div>

      

        <div class="row pt-2">
            <div class="col-lg col-md text-right">
                <button mat-flat-button color="primary" matTooltip="Limpar" class="textoGeral mr-1"
                    (click)="clearFilter()"><i class="fa fa-paint-brush" aria-hidden="true"></i> Limpar</button>
                <button mat-flat-button color="primary" matTooltip="Pesquisar" class="textoGeral mr-1"
                    (click)="sendFilter()"><i class="fa fa-search" aria-hidden="true"></i> Pesquisar</button>
            </div>
        </div>
    </form>
</div>